<script setup lang="ts">
import { twMerge } from 'tailwind-merge'
import type { Article } from '~/models/content'
import { ref } from 'vue'

const props = withDefaults(
  defineProps<{
    contentHtml?: string
    isFullscreen?: boolean
    article?: Article | null
    contentRef?: HTMLElement | null
    quoteRef?: HTMLElement | null
  }>(),
  {
    contentHtml: '',
    isFullscreen: false,
    article: null,
    contentRef: null,
    quoteRef: null,
  },
)

const content = ref<HTMLElement | null>(null)
const quote = ref<HTMLElement | null>(null)

const articleContent = computed(() =>
  props.contentHtml.replace(/data-hubspot-id="([^"]*)"/g, (match, id) => {
    const formId = id.trim()
    if (!formId) return match
    return `${match} id="hs-form-${id}"`
  }),
)

defineExpose({
  content,
  quote,
})
</script>

<template>
  <div
    :class="
      twMerge([
        'prose underline-offset-2 prose-p:text-s-900 prose-a:text-s-700 prose-a:decoration-s-400 prose-a:decoration-dotted hover:prose-a:decoration-p-900',
        isFullscreen ? 'max-w-full' : '',
      ])
    "
  >
    <div
      class="first-letter:float-left first-letter:mr-1 first-letter:text-5xl first-letter:font-bold first-letter:leading-[3rem]"
    >
      <div ref="content" v-html="articleContent" />
    </div>
  </div>

  <!-- Quote -->
  <div v-if="!isFullscreen" class="hidden">
    <div ref="quote">
      <div
        v-if="article && article.viewerCanRead && article.quote"
        class="float-none lg:float-left lg:w-28"
      >
        <blockquote
          class="relative my-5 border-y-4 border-l-0 border-s-700 py-5 pl-0 font-inter font-semibold not-italic lg:-left-56 lg:w-72"
        >
          "<div class="inline" v-html="article.quote" />"
        </blockquote>
      </div>
    </div>
  </div>
</template>
